var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contrato-detalhar',{attrs:{"dataServicos":_vm.obterDataServicos(),"rotaListagem":"Gescon_Apoios_Contratos","permiteDetalhar":_vm.$temAcessoView('GESCON-APOIO-CONT-00')}})
}
var staticRenderFns = []

export { render, staticRenderFns }